module.exports = __webpack_public_path__ + "static/img/klp1160-663-370gld.5baee20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/klp1160-663-370gld.jpg
// module id = 4MW8
// module chunks = 0